import { IComment, IUpdateCommentDTO, ICreateCommentDTO } from '@zunta/configurations'
import { IBaseStore } from '../types'
import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators'
import Api from '../../api'

export interface ICommentState {
  comments: IComment[],
}

export interface ICommentStore extends IBaseStore {
  state: ICommentState
}

@Module({
  name: 'comment',
  namespaced: true
})
export class CommentModule extends VuexModule {
  comments: IComment[] = [];

  @Mutation
  UPDATE_COMMENTS_LIST (comments: IComment[]) {
    this.comments = comments
  }

  @Mutation
  UPDATE_COMMENT (commentData: Partial<IComment>) {
    const comment = this.comments.find((comment: IComment) => comment.id === commentData.id)
    Object.keys(commentData).forEach((key: string) => {
      (comment as any)[key] = (commentData as any)[key]
    })
  }

  @Mutation
  DELETE_COMMENT (commentId: number | string) {
    this.comments = this.comments.filter((comment: IComment) => (
      comment.id !== commentId
    ))
  }

  @Action
  async fetchStatementComments (statementId: number | string) {
    const comments: IComment[] = await Api.comment.getCommentsList(statementId)
    if (Array.isArray(comments)) {
      this.UPDATE_COMMENTS_LIST(comments)
    }
  }

  @Action
  async updateComment (input: {commentId: number | string, data: IUpdateCommentDTO}) {
    const response = await Api.comment.updateComment(input.commentId, input.data)
    if (response === 'OK') {
      this.UPDATE_COMMENT({
        id: parseInt(input.commentId.toString(), 10),
        ...input.data
      })
    }
  }

  @Action
  async createComment (data: ICreateCommentDTO) {
    await Api.comment.createComment(data)
  }

  @Action
  async deleteComment (commentId: number) {
    const response = await Api.comment.deleteComment(commentId)
    if (response === 'OK') {
      this.DELETE_COMMENT(commentId)
    }
  }

  @Action
  resetStatementComments () {
    this.UPDATE_COMMENTS_LIST([])
  }

  @Action
  async fetchLetterComments (letterId: number | string) {
    const comments: IComment[] = await Api.comment.getLetterCommentsList(letterId)
    if (Array.isArray(comments)) {
      this.UPDATE_COMMENTS_LIST(comments)
    }
  }
}
